import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import MyServers from './pages/MyServers';
import MyAppeals from './pages/MyAppeals';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import CrossChatPrivacy from './pages/CrossChatPrivacy';
import Terms from './pages/Terms';
import Premium from './pages/Premium';
import NotFound from './pages/NotFound';
import SupportRedirect from "./redirects/SupportRedirect";
import InviteRedirect from "./redirects/InviteRedirect";

function RequireAuth({ user, loading, children }) {
  const location = useLocation();

  // While we're still checking the session, don't redirect yet.
  if (loading) {
    return (
      <div className="card">
        Checking your session…
      </div>
    );
  }

  // Once loading is finished, if there's no user, go to /login
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export default function App() {
  const [user, setUser] = React.useState(null);
  const [authLoading, setAuthLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    fetch('/api/auth/me', { credentials: 'include' })
      .then((r) => (r.status === 401 ? { user: null } : r.json()))
      .then(({ user }) => {
        if (!cancelled) {
          setUser(user);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setUser(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setAuthLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <Navbar user={user} onLogout={() => setUser(null)} />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home user={user} />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route
            path="/my-servers"
            element={
              <RequireAuth user={user} loading={authLoading}>
                <MyServers user={user} />
              </RequireAuth>
            }
          />
          <Route
            path="/my-appeals"
            element={
              <RequireAuth user={user} loading={authLoading}>
                <MyAppeals user={user} />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/crosschat-privacy" element={<CrossChatPrivacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/support" element={<SupportRedirect />} />
          <Route path="/invite" element={<InviteRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}
